// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"82277734","160":"2643ea5b","208":"ab14b3ff","293":"52dad0c5","516":"37053da3","519":"7ddea351","917":"af164d6f","946":"cba88c8d"}[chunkId] + ".chunk.js";
};